import React from 'react';

var TableLayout = function TableLayout(_ref) {
  var header = _ref.header,
      body = _ref.body,
      footer = _ref.footer;
  return /*#__PURE__*/React.createElement("table", null, header, body, footer);
};

export default TableLayout;